import { ActionReducerMap } from '@ngrx/store';
import { ClinicReducer, ClinicState } from './clinic';
import { ClinicEffects } from './clinic/effects';
import { GoogleMapsApiReducer, GoogleMapsApiState } from './google-maps-api';
import { GoogleMapsApiEffects } from './google-maps-api/effects';
import { NotificationReducer, NotificationState } from './notification';
import { NotificationEffects } from './notification/effects';

export interface AppState {
  [ClinicReducer.clinicFeatureKey]: ClinicState.State;
  [GoogleMapsApiReducer.googleMapsApiFeatureKey]: GoogleMapsApiState.State;
  [NotificationReducer.notificationFeatureKey]: NotificationState.State;
}

export const reducers: ActionReducerMap<AppState> = {
  [ClinicReducer.clinicFeatureKey]: ClinicReducer.reducer,
  [GoogleMapsApiReducer.googleMapsApiFeatureKey]: GoogleMapsApiReducer.reducer,
  [NotificationReducer.notificationFeatureKey]: NotificationReducer.reducer,
};

export const effects = [
  ClinicEffects,
  GoogleMapsApiEffects,
  NotificationEffects,
] as const;
